<div class="download-container" *ngIf='showing' (click)='close()'>
  <div class="card w-75">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h3>Descargar estudio</h3>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="card-body">
      <div class="row g-0">
        <div class="col-4 p-2" style="border-right: 1px solid rgba(128, 128, 128, 0.4);">
          <div class="row g-0 mb-2">
            <h4>Comenzar la descarga</h4>
          </div>
          <div class="row g-0">
            <p>Tras pulsar el botón de "Descargar", el estudio pasará al estado "Preparando...". </p>
            <p>Durante ese estado, el sistema estará preparando el estudio para su descarga.</p>
            <p> Cuanto más grande sea el estudio, más tardará</p>
          </div>
          <!-- <div class="row g-0">
            <img src="assets/img/descarga/Procesando.png" alt="">
          </div> -->
        </div>
        <div class="col-4 p-2" style="border-right: 1px solid rgba(128, 128, 128, 0.4);">
          <div class="row g-0 mb-2">
            <h4>Descargando</h4>
          </div>
          <div class="row g-0">
            <p>Una vez termine de procesarse, comenzará la descarga.</p>
            <p>La velocidad de la descarga depende del tamaño del estudio, la velocidad del proveedor de internet y la
              estabilidad de la señal.</p>
          </div>
          <div class="row g-0">
            <img style="max-width: 100%; max-height: 100%;" src="assets/img/descarga/Descargando.png" alt="">
            <img style="margin-top: 1.5rem;max-width: 100%; max-height: 100%;" src="assets/img/descarga/Descargado.png"
              alt="">
          </div>
        </div>
        <div class="col-4 p-2">
          <div class="row g-0 mb-2">
            <h4>Abrir Estudio</h4>
          </div>
          <div class="row g-0">
            <p>Cuando la descarga haya finalizado, en la carpeta de descargas se puede encontrar el archivo comprimido
              "dicomdir.zip", que contiene el estudio completo</p>
            <p>Tras extraer el archivo, se podrá visualizar con el visor que está incluido en la carpeta</p>
          </div>
          <div class="row g-0">
            <img style="max-width: 100%; max-height: 100%;" src="assets/img/descarga/Extraer_en.png" alt="">
            <img style="margin-top: 1.5rem;max-width: 100%; max-height: 100%;" src="assets/img/descarga/visor.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>